import CheckDevice from './CheckDevice'

const APP_STORE_URL = 'https://apps.apple.com/jp/app/id6772961660'
const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=jp.castgram.app'

export const REFUSE_OPEN_IN_APP_KEY = 'refuseOpenInApp'

export const hasRefusedOpenInApp = (): boolean =>
  sessionStorage.getItem(REFUSE_OPEN_IN_APP_KEY) === '1'

export const refuseOpenInApp = (): void => {
  sessionStorage.setItem(REFUSE_OPEN_IN_APP_KEY, '1')
}

export const shouldPromptOpenInApp = (
  redirectToApp: boolean | string | (string | null)[] | undefined | null
): boolean => {
  const flag = redirectToApp === true || redirectToApp === 'true'
  return CheckDevice.isMobile() && !hasRefusedOpenInApp() && flag
}

const getStoreUrl = (): string =>
  CheckDevice.getMobileOS() === CheckDevice.android
    ? PLAY_STORE_URL
    : APP_STORE_URL

/**
 * Called when the user taps "Yes".
 * iOS & Android: castgram:// via hidden iframe → app opens if installed.
 * If not opened within 2s → Store. Web page stays on the current URL.
 */
export const handleRedirectToStore = (): void => {
  if (!CheckDevice.isMobile()) return
  globalThis.location.replace(getStoreUrl())
}
